/*eslint import/no-unresolved: 2*/
import { Button, Dialog, DialogContent, Grid, makeStyles, Paper } from "@material-ui/core";
import CheckIcon from '@material-ui/icons/Check';
import DescriptionIcon from '@material-ui/icons/Description';
import EventIcon from '@material-ui/icons/Event';
import clsx from 'clsx';
import ColorButton from "components/common/ColorButton";
import { format } from "date-fns";
import { IMM_ID, RoleId, VISA_TYPE_NAME } from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import { get } from "lodash";
import mime from "mime";
import React, { useEffect, useRef, useState } from "react";
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import SignaturePad from 'react-signature-canvas';
import AppointmentService from "services/AppointmentService";
import FileService from "services/FileService";

const useStyles = makeStyles((theme) => ({
  paper: {
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  container: { width: "100%", height: "200px", top: "10%", left: "10%", display: "flex", marginTop: "50px" },
  sigContainer: { width: "80%", height: "80%", margin: "0 auto", backgroundColor: "#fff" },
  sigPad: { width: "100%", height: "100%" }, buttons: { width: "100%", height: "30px" },
  sigImage: {
    backgroundSize: "200px 50px", width: "80%", height: "80%", backgroundColor: "white", borderRadius: 15
  },
  userName: {
    fontSize: "1.25rem", fontWeight: "600", fontFamily: "system-ui", color: "#4A5C6A"
  },
  userDocNo: {
    color: "#2196F3", fontFamily: "system-ui", fontWeight: "500", lineHeight: "2", fontSize: "13px"
  },
  appointmentText: {
    color: "#003668", fontSize: "14px", display: "inline-block", fontWeight: "400", marginRight: "15px"
  },
  appointmentDate: {
    backgroundColor: "#E3F2FD", padding: "7px 10px", display: "inline-block", color: "#2196F3", fontWeight: "bold", fontSize: "14px"
  },
  wrapAppointmentDate: {
    display: 'flex',
    alignItems: 'center'
  },
  wrapappointment: {
    display: 'flex',
    alignItems: 'center', marginTop: "15px"
  },
  flexMiddle: {
    display: 'flex',
    alignItems: 'center'
  },
  tabAppointment: {
    marginTop: "36px", fontSize: "14px", borderBottom: "1px solid whitesmoke", paddingBottom: "8px"
  },
  appTitle: {
    color: 'rgba(0,0,0,0.54)',
    fontSize: "13px",
    marginTop: 35
  },
  wrapDocDetail: {
    marginTop: 30
  },
  appValue: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 15
  },
  appValue1: {
    color: "#003668", width: "150px", fontWeight: "500", fontSize: "13px"
  },
  appValue2: {
    color: "#2196F3", width: "150px", fontSize: "14px", fontWeight: "500", fontFamily: "system-ui"
  },
  wrapUserImg: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    width: '80%',
    marginTop: 10
  }
}));

function AppointmentDetailPage() {
  const classes = useStyles();
  const [signDataUri, setSignDataUri] = useState(null);
  const [imageDataUri, setImageDataUri] = useState('');
  const profile = useSelector((state) => state.user.profile);
  const sigPad = useRef({});

  const [open, setOpen] = React.useState(false);
  const params = useParams();
  const draftId = get(params, "draftId", "") || "";
  const [stampDetail, setStampDetail] = useState(null);
  const history = useHistory();
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const clear = () => {
    sigPad.current.clear()
  }
  const trim = () => {
    setSignDataUri(sigPad.current.getTrimmedCanvas().toDataURL('image/png'))
  }


  useEffect(async () => {
    await getAppointment();

  }, [])

  const getAppointment = async () => {
    const res = await AppointmentService.getAppointments({ draftId: draftId });
    if (res.status && res.results?.length > 0) {
      const detail = res.results[0];

      setStampDetail(detail);



      if (detail.userProfileFileId) {
        const data = await FileService.getFile(detail.userProfileFileId);
        try {
          const fileName = detail.userProfileFileName + detail.userProfileFileExt;
          const blobFile = new File([data], fileName, {
            type: mime.getType(detail.userProfileFileExt),
          });


          setImageDataUri(URL.createObjectURL(blobFile))
        } catch (error) {
          console.error(error);
        }
      }
      if (detail.userSignedFileId) {
        const data = await FileService.getFile(detail.userSignedFileId);
        try {
          const fileName = detail.userSignedFileName + detail.userSignedFileExt;
          const blobFile = new File([data], fileName, {
            type: mime.getType(detail.userSignedFileExt),
          });

          setSignDataUri(URL.createObjectURL(blobFile))
        } catch (error) {
          console.error(error);
        }
      }
    }
    else {
      setStampDetail(null);
    }
  }




  const handleClose = (dataUri) => {
    if (dataUri) {
      setImageDataUri(dataUri);
    }
    setOpen(false);
  };

  console.log(profile);
  return (
    <Paper className={classes.paper} id="admin-view">
      <CameraDialog open={open} onClose={handleClose} />



      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <div>
            {
              imageDataUri &&
              <>
                <img className={classes.sigImage}
                  src={imageDataUri} />
                <div className={classes.wrapUserImg}>

                  {
                    stampDetail?.stampStatus === 'P' &&
                    <>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        className={classes.buttonViewDetail}
                        style={{ marginRight: 10 }}
                        onClick={() => {
                          setImageDataUri(null)
                          setOpen(true)
                        }}>
                        แก้ไข
                      </Button>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        className={classes.buttonViewDetail}
                        onClick={() => {
                          setImageDataUri(null)
                        }}>
                        ลบ
                      </Button>
                    </>
                  }

                </div>

              </>
            }
            {
              !imageDataUri &&
              (stampDetail?.empAssignedId === profile.userID ||
                profile.departmentId === IMM_ID && profile.roleId === RoleId.Supervisor ||
                profile.departmentId === IMM_ID && profile.roleId === RoleId.Director
              ) &&
              <>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className={classes.buttonViewDetail}
                  onClick={() => {
                    setOpen(true)
                  }}>
                  ถ่ายรูป
                </Button>
              </>
            }

          </div>
        </Grid>
        <Grid item xs={12} md={8}>
          <div>
            <div className={classes.userName}>
              ข้อมูลการนัดประทับตรา
            </div>
            <div className={classes.userDocNo}>
              เลขที่เอกสาร:
              <span style={{ textDecoration: "underline", paddingLeft: "10px", cursor: "pointer" }} onClick={() => {
                window.open(`/admin/smart-visa/document/${draftId}`, "_blank");

              }}>{stampDetail?.docNo}</span>
            </div>
            <div className={classes.wrapappointment}>
              <div className={classes.wrapAppointmentDate}>
                <EventIcon style={{ marginRight: 5, fontSize: 18 }} />
                <div className={classes.appointmentText}>
                  วันที่นัดหมาย
                </div>
              </div>
              <div className={classes.appointmentDate}>
                <div className={classes.wrapAppointmentDate}>
                  <CheckIcon style={{ marginRight: 10 }} />
                  <span>
                    {stampDetail?.stampDate && format(new Date(stampDetail?.stampDate), "yyyy-MM-dd")}
                  </span>
                </div>


              </div>
            </div>

          </div>
          <div>
            <div className={classes.tabAppointment}  >

              <div className={clsx(classes.flexMiddle)} >
                <DescriptionIcon style={{ marginRight: 5, fontSize: 18 }} />
                <div className={classes.appointmentText}>
                  รายละเอียด
                </div>
              </div>
            </div>


          </div>
          <div className={classes.wrapDocDetail}>
            <div className={classes.appTitle}>
              ข้อมูลผู้ยื่น
            </div>
            <div className={classes.appValue}>
              <div className={classes.appValue1}>
                เลขที่เอกสาร
              </div>
              <div className={classes.appValue2}>
                {stampDetail?.docNo}
              </div>
            </div>
            <div className={classes.appValue}>
              <div className={classes.appValue1}>
                ประเภทคำขอ
              </div>
              <div className={classes.appValue2}>
                {VISA_TYPE_NAME[stampDetail?.visaType]}
              </div>
            </div>
            <div className={classes.appValue}>
              <div className={classes.appValue1}>
                ชื่อ-สกุล
              </div>
              <div className={classes.appValue2}>
                {stampDetail?.personalFirstName}    {stampDetail?.personalLastName}
              </div>
            </div>

            <div className={classes.appTitle}>
              เจ้าหน้าที่ที่รับผิดชอบ
            </div>

            <div className={classes.appValue}>
              <div className={classes.appValue1}>
                ชื่อ-สกุล
              </div>
              <div className={classes.appValue2}>
                {stampDetail?.empAssignedFirstName}  {stampDetail?.empAssignedLastName}
              </div>
            </div>

            <div className={classes.appValue}>
              <div className={classes.appValue1}>
                อีเมล
              </div>
              <div className={classes.appValue2}>
                {stampDetail?.empAssignedEmail}
              </div>
            </div>

            {
              stampDetail?.stampStatus === 'C' &&
              <>

                <div className={classes.appTitle}>
                  เจ้าหน้าที่ที่อนุมัติ
                </div>

                <div className={classes.appValue}>
                  <div className={classes.appValue1}>
                    ชื่อ-สกุล
                  </div>
                  <div className={classes.appValue2}>
                    {stampDetail?.empApprovedFirstName}  {stampDetail?.empApprovedLastName}
                  </div>
                </div>

                <div className={classes.appValue}>
                  <div className={classes.appValue1}>
                    อีเมล
                  </div>
                  <div className={classes.appValue2}>
                    {stampDetail?.empApprovedEmail}
                  </div>
                </div>
              </>
            }
          </div>

          <div className={classes.container}>
            <div className={classes.sigContainer}>
              {
                !signDataUri &&
                <div style={{ border: "1px solid darkgray", borderRadius: "15px" }}>
                  <SignaturePad
                    canvasProps={{ className: classes.sigPad }}
                    ref={sigPad} />
                </div>

              }
              {signDataUri
                ? <img className={classes.sigImage}
                  src={signDataUri} />
                : null}
            </div>
            <div>
              {
                signDataUri && stampDetail?.stampStatus === 'P' &&
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  className={classes.buttonViewDetail}
                  onClick={() => {
                    setSignDataUri(null);
                  }}>
                  เขียนใหม่
                </Button>
              }
              {
                !signDataUri &&
                (stampDetail?.empAssignedId === profile.userID ||
                  profile.departmentId === IMM_ID && profile.roleId === RoleId.Supervisor ||
                  profile.departmentId === IMM_ID && profile.roleId === RoleId.Director
                ) &&
                <>
                  <div style={{ marginBottom: 15 }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      className={classes.buttonViewDetail}
                      onClick={clear}>
                      ล้าง
                    </Button>
                  </div>
                  <div style={{ marginBottom: 15 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className={classes.buttonViewDetail}
                      onClick={trim}>
                      ยืนยัน
                    </Button>
                  </div>
                </>
              }

            </div>

          </div>
          <div>
            {
              stampDetail?.stampStatus === 'P' &&
              (stampDetail?.empAssignedId === profile.userID ||
                profile.departmentId === IMM_ID && profile.roleId === RoleId.Supervisor ||
                profile.departmentId === IMM_ID && profile.roleId === RoleId.Director
              ) &&
              <>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonViewDetail}
                  onClick={async () => {
                    if (!signDataUri) {
                      alert('กรุณาเซ็นลายเซ็น');
                      return;
                    }
                    if (!imageDataUri) {
                      alert('กรุณาถ่ายรูป');
                      return;
                    }

                    if (!window.confirm('Do you want to apporve this appointment?')) { return; }

                    showAdminLoading();

                    const filesignDataUri = await fetch(signDataUri)
                      .then(res => res.blob())
                      .then(blob => {
                        const file = new File([blob], "signImg.png", { type: "image/png" })
                        return file
                      })


                    const fileimageDataUri = await fetch(imageDataUri)
                      .then(res => res.blob())
                      .then(blob => {
                        const file = new File([blob], "userImg.png", { type: "image/png" })
                        return file
                      })


                    const resSign = await FileService.uploadFile({
                      file: filesignDataUri,
                      Status: true,
                    });

                    const resImg = await FileService.uploadFile({
                      file: fileimageDataUri,
                      Status: true,
                    });


                    if (resSign.status && resImg.status) {


                      const signFileId = resSign.results?.fileID;
                      const imgFileId = resImg.results?.fileID;

                      const body = {
                        draftId: draftId,
                        userProfileFileId: imgFileId,
                        userSignedFileId: signFileId,
                        status: true

                      };

                      const resApp = await AppointmentService.adminApproveAppointment(body);

                      if (resApp.status) {
                        await getAppointment();
                      }

                      hideAdminLoading();
                    }
                  }}>
                  ยืนยันประทับตรา
                </Button>


              </>
            }

            {
              (stampDetail?.empAssignedId === profile.userID ||
                profile.departmentId === IMM_ID && profile.roleId === RoleId.Supervisor ||
                profile.departmentId === IMM_ID && profile.roleId === RoleId.Director
              ) &&
              <ColorButton
                variant="outlined"
                color="error"
                style={{ marginLeft: 10 }}
                className={classes.buttonViewDetail}
                onClick={async () => {
                  if (!window.confirm('Do you want to cancel this appointment?')) { return; }

                  const body = {
                    draftId: draftId,
                    userProfileFileId: null,
                    userSignedFileId: null,
                    status: false
                  };

                  const resApp = await AppointmentService.adminApproveAppointment(body);

                  if (resApp.status) {
                    alert('canceled!')
                    history.push('/admin/smart-visa/issuance-appointment')

                  }
                }}>
                ยกเลิก
              </ColorButton>
            }

          </div>
        </Grid>
      </Grid>

    </Paper >
  );
}

export default AppointmentDetailPage;



function CameraDialog(props) {
  const classes = useStyles();
  const { onClose, open } = props;
  const [dataUri, setDataUri] = useState('');


  const handleClose = () => {
    onClose();
  };

  function handleTakePhotoAnimationDone(dataUri) {
    setDataUri(dataUri);
    onClose(dataUri);
  }

  const isFullscreen = false;
  return (
    <Dialog onClose={handleClose} open={open} >
      <DialogContent style={{ width: 600, height: 480 }}>
        <div style={{}}>
          <Camera onTakePhotoAnimationDone={handleTakePhotoAnimationDone}
            isFullscreen={isFullscreen}
          />



        </div>

      </DialogContent>
    </Dialog>
  );
}